import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SaleorderTypeAdapter } from './dto/sale-order-type.adapter';
import { SaleorderType } from './sale-order-type.entity';
import { SaleOrderTypeController } from './sale-order-type.controller';
import { SaleOrderTypeService } from './sale-order-type.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

@Module({
  imports: [
    TypeOrmModule.forFeature([SaleorderType]),
    ],
  controllers: [SaleOrderTypeController],
  providers: [SaleOrderTypeService,SaleorderTypeAdapter,ApplicationExceptionHandler]
})

export class SaleOrderTypeModule {


}
